import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import {
	fetchAllMessagesError,
	fetchAllMessagesStart,
	fetchAllMessagesSuccess,
} from '../actions/messages_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { ROLE_TYPES } from '../utils/DataConstants';
import {
	NOTE_TYPE_LOG,
	NOTE_TYPE_NOTE,
	NOTE_TYPE_SERVICE_CALL_CHECK_IN,
	NOTE_TYPE_SERVICE_CALL_CHECK_OUT,
} from '../constants/NoteTypes';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export const mergeAndSortData = (
	data: { notes?: any[]; logs?: any[]; serviceCallCheckInCheckOutDetails?: any[] } = {
		notes: [],
		logs: [],
		serviceCallCheckInCheckOutDetails: [],
	}
) => {
	const notes = (data.notes || []).map((note) => ({
		...note,
		type: NOTE_TYPE_NOTE,
		timestamp: new Date(note.noteAddedAt).getTime(),
	}));

	const logs = (data.logs || []).map((log) => ({
		...log,
		type: NOTE_TYPE_LOG,
		timestamp: new Date(log.changedAt).getTime(),
	}));

	const serviceCallDetails = data.serviceCallCheckInCheckOutDetails || [];

	const serviceCallCheckIns = serviceCallDetails
		.filter(function (sc) {
			return sc.checkInTime;
		})
		.map(function (sc) {
			return {
				...sc,
				type: NOTE_TYPE_SERVICE_CALL_CHECK_IN,
				timestamp: new Date(sc.checkInTime).getTime(),
			};
		});

	const serviceCallCheckOuts = serviceCallDetails
		.filter(function (sc) {
			return sc.checkOutTime;
		})
		.map(function (sc) {
			return {
				...sc,
				type: NOTE_TYPE_SERVICE_CALL_CHECK_OUT,
				timestamp: new Date(sc.checkOutTime).getTime(),
			};
		});

	const mergedData = [...notes, ...logs, ...serviceCallCheckIns, ...serviceCallCheckOuts].sort(
		(a, b) => a.timestamp - b.timestamp
	);

	return mergedData.map((entry) => {
		const { timestamp, ...rest } = entry;
		return rest;
	});
};
const fetchAllWorkOrderNotes = (roleType) => (workOrderId) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(fetchAllMessagesStart(workOrderId));
			fetchUtils
				.get(baseUrl + `/api/v1/${roleType}/work_order/work_order_notes_with_logs/${workOrderId}`, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(fetchAllMessagesError(d.message, workOrderId));
						reject(d.message);
					} else {
						dispatch(fetchAllMessagesSuccess(workOrderId, mergeAndSortData(d.data)));
						resolve(mergeAndSortData(d.data));
					}
				})
				.catch((d) => {
					dispatch(fetchAllMessagesError(d.message, workOrderId));
					reject(d.message);
				});
		});
	};
};

export const fetchAllWorkOrderNotesForBuyer = fetchAllWorkOrderNotes(ROLE_TYPES.BUYER);
export const fetchAllWorkOrderNotesForSupplier = fetchAllWorkOrderNotes(ROLE_TYPES.SUPPLIER);

export const fetchAllContractorWorkOrderNotes = (roleType) => (workOrderId) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(fetchAllMessagesStart(workOrderId));
			fetchUtils
				.get(
					baseUrl + `/api/v1/${roleType}/work_order/contractor_work_order_notes/${workOrderId}`,
					{
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					}
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(fetchAllMessagesError(d.message, workOrderId));
						reject(d.message);
					} else {
						dispatch(fetchAllMessagesSuccess(workOrderId, d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(fetchAllMessagesError(d.message, workOrderId));
					reject(d.message);
				});
		});
	};
};
